import React, { useMemo } from 'react';
import styled from 'styled-components';

import MissionDetailsAchievementContainer from '../MissionDetailsAchievement/MissionDetailsAchievementContainer';

const Wrapper = styled.div`
  position: relative;
`;

const StyledMissionDetailsAchievementContainer = styled(MissionDetailsAchievementContainer)`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 0.67em;
  }
`;

type MissionDetailsAchievementsListProps = {
  className?: string;
  missionId: number;
  achievementIds: Array<number>;
};

const MissionDetailsAchievementsList = ({
  className = '',
  achievementIds,
  missionId,
}: MissionDetailsAchievementsListProps) => {
  const shouldRender = useMemo(
    () => typeof missionId === 'number' && !!achievementIds.length,
    [missionId, achievementIds],
  );

  return shouldRender ? (
    <Wrapper className={className}>
      {achievementIds.map((achievementId) => (
        <StyledMissionDetailsAchievementContainer
          key={`mission-details-achievement-${achievementId}`}
          achievementId={achievementId}
          missionId={missionId}
        />
      ))}
    </Wrapper>
  ) : null;
};

export default MissionDetailsAchievementsList;
